<template>
  <p>
    <small>
      {{ I18n.t("artworks.accepting_sales_conditions") }}
    </small>
    <br>
    <b-btn v-b-tooltip.hover
           :title="artwork.auctionsCatalog.auctionHouseBiddingRules"
           class="btn-link link--orange global-search__tooltip--sales_conditions p-0" >
      <small>
        {{ I18n.t("artworks.sales_conditions") }}
      </small>
    </b-btn>
  </p>
</template>

<script>
  export default {
    name: 'SalesConditions',
    props: {
      artwork: {
        type: Object,
        required: true,
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/search_page/index/components/artworks_tab/modal/orders/sales_conditions.vue?068799ec